import { config } from '../config'
import { Title, SubTitle, ListItem, List } from '../styles'

import { Wrapper } from './styles'

const {
  challenge: { title, subtitle, list },
} = config

export function Challenges() {
  return (
    <Wrapper>
      <Title as="h2">{title}</Title>
      <SubTitle>{subtitle}</SubTitle>
      <List>
        {list.map(task => (
          <ListItem key={task}>{task}</ListItem>
        ))}
      </List>
    </Wrapper>
  )
}
